
define(function (require) {
    "use strict";

    var FacebookPageView = require("manager-views/data-sources/conversation-sources/facebook/FacebookPageView");

    var FacebookPagesView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        FacebookPagesView = Marionette.CollectionView.extend({

            itemView: FacebookPageView,

            initialize: function (options) {
                this._initialize(options);
            },
            _initialize: function (options) {
                options = options || {};
                this.connectorModels = options.connectorModels;
                this.itemViewOptions = {
                    connectorModels: this.connectorModels
                };
            },
            setConnectorModels: function(options){
                LEManager.logger.debug("FacebookPageView:setConnectorModels options: " + options);
                this._initialize(options);
                this.closeChildren(); //marionette public method to close all the item views
                this.render();
            },
            onClose: function(){
                LEManager.logger.debug("FacebookPageView:onClose");
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return FacebookPagesView;
});




